<template>
  <div>
    <div class="card">
      <h1>Signaler un bug ou une erreur</h1>
      <p>Tu as rencontré un bug ? Une erreur ? Une faute ? Les trois à la fois ? N'hésite pas à nous faire part de tes découvertes en signalant le problème que tu rencontres, ça nous permettra de rendre le site encore meilleur !</p>
      <p><br>Pour toute question ou signalement concernant un problème technique, tu peux nous contacter par mail.</p>
      <div id="contact-container">
        <a class="contact-group" href="mailto:contact@sv-quiz.fr">
          <img class="illu-img" src="../assets/mail.png" alt="Icone d'un Mail">
          <h3>contact@sv-quiz.fr</h3>
        </a>
      </div>
    </div>
  </div>
</template>


<style scoped>
  .card {
    width: 70%;
    margin-left: auto;
    margin-right: auto;
  }
  #contact-container {
    margin: 42px 0 10px;
    display: flex;
    justify-content: space-evenly;
  }
  .contact-group {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .illu-img {
    height: 110px;
    margin: 0 0 7px;
  }


  @media screen and (max-width: 1400px) {
    .card {
      width: 85%;
    }
  }
  @media screen and (max-width: 720px) {
    .card {
      width: 96%;
    }
  }
</style>
<script>
export default {
  mounted() {
    window.scrollTo(0, 0)
  }
}
</script>